const getTimeZone = () => (new Date().toLocaleTimeString(undefined, { timeZoneName: 'short' }).split(' ')[2]);
export default getTimeZone;
//# sourceMappingURL=getTimeZone.js.map